<template>
  <div>
    <div class="page-content">
      <div class="agree-wrapper" v-show="mxIsContract < 0">
        <el-row>
          <el-col :span="24">
            <div class="agree-header">
              <i class="el-icon-warning"></i>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="agree-title">该公司未绑定合同，请上传合同文件</div>
          </el-col>
        </el-row>
      </div>
      <el-row class="contact-upload" v-show="mxIsContract < 0">
        <el-form ref="contractForm" :model="formData" :rules="rules" label-width="100px">
          <el-col :span="24" class="content-left">
            <el-form-item label="上传文件" prop="file_url">
              <upload-file
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                :title="title"
                :multiple="'false'"
                :multiSelection="false"
                :dir="'bill'"
                :selectfiles="'importExcel'"
                :postfiles="'submitImportExcel'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div class="warn-title" v-show="mxIsContract == 0" style="margin-top: 120px">合同审核中，请稍后再试或联系管理员尽快审核</div>
      <div class="warn-title" v-show="mxIsContract == 2" style="margin-top: 120px">合同审核失败，请联系管理员</div>
    </div>
  </div>
</template>

<script>
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
export default {
  name: 'Agreement',
  components: {
    ModalDialog,
    UploadFile
  },
  data() {
    return {
      title: '合同',
      isShow: false,
       dialogData:{
        visible: false,
        title: '',
        width: '45%',
        loading: true,
        modal: true
      },
      rules: {},
      formData:{
        file_url: '',
        status: 0
      },
    };
  },
  methods: {
    goTo() {
      this.isShow = true
    },
     // 响应添加按钮1
    async addButton(pid) {
      // 添加子权限，拼接的前缀
      // if (name) {
      //   this.namePrefix = name+'_'
      // }
      this.dialogData.visible = true
      this.dialogData.title = pid?'添加子权限':'添加权限'
      this.initForm()
    },
    // 初始化form，将添加，编辑共同数据抽取出来
    async initForm() {
      this.dialogData.loading = false
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initData()
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.isInherit= true
        this.namePrefix= ''
        this.formData = {
          display_name:''
        }
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['contractForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    //导入跳转
    importExcel() {
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
    },
     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename}) {
      console.log("->上传成功....",url, filename);
      this.formData.file_url = url
      this.formSubmit()
    },
    async formSubmit() {
      console.log("formData -> ", this.formData);
      try {
        let id = await this.$api.saveContract(this.formData)
        if (id) {
          this.$notify.success('保存成功！')
          this.mxInitUserInfo()
          this.mxRedirect('/')
        }
      } catch(err) {
        console.log('err is ->', err)
      }
    },
    // 返回列表
    returnList() {
      this.$router.push('/bill')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
  },
  created() {
    this.mxRedirectFilterUrl('/')
  },
  computed: {
    isRootRoutePath: function() {
      return this.$route.path == "/";
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-container
  background: #f0f2f5
.el-aside
  min-height: 100vh
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35)
  position: relative
  width: auto !important
  z-index: 10
  transitionall: 0.3s
  background: #2c343f
.el-header
  height: 64px !important
  padding: 0px
  width: 100%
.el-main
  padding: 0px
  margin: 24px
  overflow: inherit
  flexnone: @css  !important
  min-height: 720px
.main-page-content
  border-radius: 5px
  background: #ffffff
  padding: 24px
.el-footer
  height: auto !important
.el-row
  margin-bottom: 20px
  &:last-child
    margin-bottom: 0
.el-col
  border-radius: 4px
.bg-purple-dark
  background: #99a9bf
.bg-purple
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  padding: 20px 30px
  font-size: 20px
  background: #F7F8FA
.info-title, .info-price
  padding: 5px
.info-title
  color: #333
.info-img
  width: 55px
  height: 55px
.bg-purple-light
  background: #e5e9f2
.grid-content
  border-radius: 4px
  min-height: 36px
.row-bg
  padding: 10px 0;
  background-color: #f9fafc
.page-header
  background: #fff
  padding: 16px 32px 0 32px
  border-bottom: 1px solid #e8e8e8
.page-content
  margin: 0 auto

.main-page-content
  min-height: 600px
.agree-header
  display: flex
  flex-direction: row
  justify-content: center
  color: rgba(255, 149, 2, 1)
  margin-top: 20px
  font-size: 100px
.agree-title
  width: 978px
  background-color: rgba(255, 255, 255, 0)
  color: rgba(166, 23, 23, 1)
  font-size: 18px
  text-align: center
  font-family: Roboto
  margin: 0 auto
.go-to
  position: absolute
  bottom: 100px
  right: 100px
.warn-title
  width: 1143px
  height: 50px
  line-height: 50px
  margin: 0 auto
  border-radius: 5px 5px 5px 5px
  background-color: rgba(82, 80, 80, 1)
  color: #fff
  font-size: 20px
  text-align: center
  font-family: Roboto
  border: 1px solid rgba(187, 187, 187, 1)
.table-header
  margin-bottom 12px
.contact-upload
  padding-top: 50px
  width: 980px
  margin: 0 auto
</style>
